type BadgeTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral'

/**
 * Жизненный цикл счёта — словарь платёжного модуля, взятый дословно:
 * pending → detected → confirmed, плюс expired и cancelled. Свои здесь только
 * creating (счёт заведён у нас, модуль о нём ещё не знает) и failed (завести
 * его так и не удалось).
 *
 * Карта открытая: незнакомый статус всё равно отрисуется, нейтральным.
 */
export function invoiceStatusTone(status: string): BadgeTone {
  switch (status) {
    case 'confirmed':
      return 'success'
    case 'detected':
      return 'info'
    case 'pending':
      return 'warning'
    case 'failed':
      return 'danger'
    case 'creating':
    case 'expired':
    case 'cancelled':
      return 'neutral'
    default:
      return 'neutral'
  }
}

/**
 * Статусы, на которых опрос останавливается.
 *
 * `expired` в списке с оговоркой: модуль держит сумму занятой ещё пару часов
 * после истечения, и перевод, пришедший в это окно, всё ещё закрывает счёт.
 * Такой счёт оживёт — но узнает об этом крон сверки, а не вкладка, открытая
 * на два часа. Возвращение на страницу перечитает список.
 */
const TERMINAL_STATUSES = new Set(['confirmed', 'expired', 'cancelled', 'failed'])

export const isTerminalInvoice = (status: string): boolean => TERMINAL_STATUSES.has(status)
